import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import DiscreteTabs from 'components/DesignSystem/Tabs/DiscreteTabs';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/agroLayoutReducer';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function TrackingForecast() {
  const isMobile = useIsMobile();

  useEffect(() => {
    // Keep the Agro sidebar in sync with the only subpage currently exposed here.
    store.dispatch(setCurrentTab('agro/trackingforecast/detailedview'));
  }, []);

  return (
    <div>
      {!isMobile && (
        <DiscreteTabs
          type="underline"
          activeKey="./"
        >
          {/* <DiscreteTabs.Tab path="/agro/trackingforecast/" title="Mapas" /> */}
          <DiscreteTabs.Tab path="/agro/trackingforecast/detailedview/" title="Visão Detalhada" />
        </DiscreteTabs>
      )}
      <div>
        <Outlet />
      </div>
    </div>
  );
}
